<template>
  <div class="home">
    <!-- <div id="fb-root"></div> -->
    <header id="top-head" class="header">
      <h1><a class="header__logo" href="#" v-scroll-to="'#app'">松本文字塾第二期 文字塾展 「どこまでも もじはつづくよ かなの旅」</a></h1>
      <nav id="global-nav" class="global__nav">
        <a href="#period" class="gnav__item gnav__01">会期</a>
        <a href="#about" class="gnav__item gnav__02">展示について</a>
        <a href="#pamphlet" class="gnav__item gnav__03">冊子</a>
        <a href="#talkevent" class="gnav__item gnav__04">トークイベント</a>
        <a href="#access" class="gnav__item gnav__05">アクセス</a>
        <a href="#qanda" class="gnav__item gnav__06">Q&amp;A</a>
      </nav>

      <div class="navbar-end">
        <b-dropdown aria-role="list" :mobile-modal="false" position="is-bottom-left">
          <button class="button is-primary" slot="trigger" slot-scope="{ active }">
            <span class="header__dropdownbtn__icon" :class="active ? 'menu-up' : 'menu-down'">▼</span>
          </button>

          <b-dropdown-item aria-role="listitem" href="#period" class="gnav__item gnav__01">会期</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#about" class="gnav__item gnav__02">展示について</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#pamphlet" class="gnav__item gnav__03">冊子</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#talkevent" class="gnav__item gnav__04">トークイベント</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#access" class="gnav__item gnav__05">アクセス</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#qanda" class="gnav__item gnav__06">Q&amp;A</b-dropdown-item>

        </b-dropdown>
      </div>

    </header>

    <div class="mainContent">
      <section class="topimg">
        <div class="landscape" role="img" aria-label="img">
          <div class="landscape__layer">
            <div class="landscape__title" style="--offset: 1">
              <img src="../assets/img/top/title.svg" alt="どこまでも もじはつづくよ かなの旅">
          </div>
          <div class="landscape__layer" style="--offset: 0.6">
            <div class="landscape__image">
              <img src="../assets/img/top/mountain.svg" alt="山並み">
            </div>
          </div>
          <div class="landscape__layer" style="--offset: 0.4">

            <div class="landscape__image">
              <img src="../assets/img/top/range_full.svg" alt="山脈">
            </div>
          </div>

            <!-- <div class="landscape__mojijuku">
              <img src="../assets/img/top/mojijuku.svg" alt="松本文字塾第二期">
            </div> -->
          </div>
          <!-- <div class="landscape__layer">
            <div class="landscape__image">
              <img src="../assets/img/top/range.svg" alt="山脈">
            </div>
          </div> -->
          <!-- <div class="landscape__layer">
            <div class="landscape__image">
              <img src="../assets/img/top/mojijuku.svg" alt="松本文字塾第二期">
            </div>
          </div> -->
        </div>
          <!-- <div class="topinfo--logo"> -->
            <!-- <img src="../assets/img/top/title.svg" alt=""> -->
            <!-- <img src="../assets/img/logo_01.svg" alt="">
            <img src="../assets/img/logo_02.svg" alt=""> -->
          <!-- </div> -->
          <!-- <div class="topinfo--mountain"> -->
            <!-- <img src="../assets/img/top/mountain.svg" alt=""> -->
          <!-- </div> -->
      </section>

      <section class="period">
        <div class="period">
          <h2 class="title h2">会期<a id="period" class="hash_anchor"></a></h2>
          <p class="date">
            <!-- <span>2024</span>年<span>6</span>月<span>2</span>日（土）<span>8</span>日（日）<span>9</span>日（月祝）、<br><span>14</span>日（土）<span>15</span>日（日）12時 – 18 -->
            <span>2024</span>年
            <span>6</span>月
            <span>2</span>日（日）
            <span>– 9</span>日（日）<br>
            <!-- <span>6</span>月<span>2</span>日（日）<span>– 7</span>日（金）<span>13:30 – 18:30</span><br> -->
            <!-- <span>6</span>月<span>8</span>日（土）<span>11:30 – 17:30</span><br> -->
            <!-- <span>6</span>月<span>9</span>日（土）<span>13:30 – 16:30</span> -->
          </p>

          <div class="columns timetable">
            <div class="column student">
              <div class="text mt-0">
                <div class="namejob">
                  <div class="name">6月2日<span class="is-hidden-mobile">（日）</span>– 7日<span class="is-hidden-mobile">（金）</span></div>
                  <div class="centerLine"><hr></div>
                  <div class="job">13:30 – 18:30</div>
                </div>
                <div class="namejob with--description">
                  <div class="name">6月8日<span class="is-hidden-mobile">（土）</span></div>
                  <div class="centerLine"><hr></div>
                  <div class="job">11:30 – 17:30</div>
                </div>
                <div class="description">トークイベント 14:00 – 17:00</div>
                <div class="namejob with--description">
                  <div class="name">6月9日<span class="is-hidden-mobile">（日）</span></div>
                  <div class="centerLine"><hr></div>
                  <div class="job">13:30 – 16:30</div>
                </div>
                <div class="description">トークイベントその2 11:00 – 12:30</div>
              </div>
            </div>
          </div>
          <!-- <b-field><b-tag type="is-warning"><span class="notes">日により開場時間が異なりますのでご注意ください</span></b-tag></b-field> -->
          <!-- <p class="mt-6">トークイベント：6月8日（土）14:00 – 17:00</p> -->
          <!-- <p class="mt-6">展示会場：マツモトアートセンター</p>
          <p>トークイベント会場：<a target="_blank" href="https://noyie.jp/">ギャラリーノイエ</a>（展示会場から徒歩約7分）</p> -->

          <div class="columns timetable is-hidden-mobile">
            <div class="column student">
              <div class="text mt-0">
                <div class="namejob">
                  <div class="name">展示会場</div>
                  <div class="centerColon"><hr></div>
                  <div class="job">マツモトアートセンター 2階</div>
                </div>
                <div class="namejob with--description">
                  <div class="name">トークイベント会場</div>
                  <div class="centerColon"><hr></div>
                  <div class="job">ギャラリーノイエ</div>
                </div>
                <div class="description description--small">（展示会場から徒歩約7分）</div>
              </div>
            </div>
          </div>

          <p class="caption is-size-6">＊展示は入場無料です。<br/>＊日により開場時間が異なりますのでご注意ください。</p>

        </div>
        <!-- <div class="period">
          <p class="date mt-6" v-if="sessionalStatus === 'pre'" v-html="startDateCountDownStr"></p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'pre'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日HH:mm')"></span>の間、会場でのみ公開されます。期間中はぜひ会場へお越しください。</p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'post'">作品の展示は<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>をもちまして終了いたしました。たくさんのご来場・視聴をいただきましてありがとうございました。</p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'mid'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。作品は作品閲覧からご覧ください。作品の解説は動画解説をご覧ください。</p>
        </div> -->
      </section>

      <section class="about">
        <h2 class="title h2">展示について<a id="about" class="hash_anchor"></a></h2>
        <div class="columns is-desktop about__description">
          <div class="column torinoumimessage">
            <h3 class="h3">文字塾展ご挨拶</h3>
            <div class="is-serif">
              <p>文字塾は、塾生が１年をかけてそれぞれの明朝体の仮名をデザインする私塾です。</p>
              <p>第８期まで東京を拠点に実施していましたが、コロナ禍で２年間の中断を余儀なくされ、私が安曇野市へ移住したこともあり、２０２２年４月から信州松本に拠点をおいて松本文字塾として再スタートしました。</p>
              <p>今回の展示は、２０２３年度の第２期の塾生によるものです。塾生は、東京、神奈川、京都、岐阜、福井、群馬、山梨などから通いました。外国からは中国の方が１名、台湾の方が２名参加しました。中でも台湾の曾さんは毎回台湾から通うという強者です。</p>
              <p>総勢16名の塾生が集い、各自が定めたコンセプトのもと、１年間、自身の文字と向き合いました。手で書き、迷い、修整を繰り返した結果が今回展示した作品です。明朝体もあれば、そうでない書体もあります。これは塾生の経験の記録であり、のびしろのある完成途上のものです。作品だけでなく、一冊のファイルにまとめられた制作過程も必見です。北アルプスが望める信州松本まで足を運び、多くの皆さんに観てもらえたら幸いです。</p><br>
              <p>また、６月８日（土）には、グラフィックデザイナーの田中義久さんをお迎えしてトークショーを行います。田中さんとは、東京都写真美術館のロゴ制作で知りあい、その後、田中さんたちが手がけていた雑誌「疾駆」に「横組み用仮名を作ってみる」というタイトルで、私が実際に仮名を作りながらその過程を連載しました。それは後に修整が加えられて「水面かな」という仮名書体になりました。</p>
              <p>田中さんとはそれくらいの付き合いしかなく、申し訳ないことに書体に対してどのような定見をお持ちか知りません。それでもお呼びしたい一番の理由は、田中さんは澄んだ感性を持った気持ちの良い人（！）だと思うからです。</p>
              <p>私には及びもつかないとてもヘンテコな作品を作る田中さんが、塾生が制作した文字に対してどのような反応をみせるのか興味津々です。田中さんの口からどんな言葉が飛び出すのかとても楽しみです。</p><br>
              <p>松本は松本城を擁する城下町です。文字塾展を観たあと、雰囲気の良い町を歩き、馬刺しや山賊焼きを肴に地酒を呑んで、締めに信州そばもいいですね。カレーも美味しい店があるようです。是非おいでください。</p>
              <p class="has-text-right is-serif mt-7">松本文字塾塾長　鳥海修</p>
              <!-- <p class="has-text-right is-serif">協力：松本タイポグラフィ研究会</p> -->
              <!-- <p class="has-text-right is-serif">協力：Book&amp;Design・松本タイポグラフィ研究会</p> -->
            </div>
          </div>
          <div class="column student">
            <h3 class="h3">参加者</h3>
            <div class="namejob">
              <div class="name">稲岡莉々</div>
            </div>
            <div class="namejob">
              <div class="name">落合あや子</div>
            </div>
            <div class="namejob">
              <div class="name">佐藤美羽</div>
            </div>
            <div class="namejob">
              <div class="name">篠鉄平</div>
            </div>
            <div class="namejob">
              <div class="name">朱心茹</div>
            </div>
            <div class="namejob">
              <div class="name">榛葉眞利子</div>
            </div>
            <div class="namejob">
              <div class="name">鈴木彩恵実</div>
            </div>
            <div class="namejob">
              <div class="name">曾國榕</div>
            </div>
            <div class="namejob">
              <div class="name">高橋さくら</div>
            </div>
            <div class="namejob">
              <div class="name">田中千尋</div>
            </div>
            <div class="namejob">
              <div class="name">都筑尭志</div>
            </div>
            <div class="namejob">
              <div class="name">舟山貴士</div>
            </div>
            <div class="namejob">
              <div class="name">前田凜</div>
            </div>
            <div class="namejob">
              <div class="name">松本向日葵</div>
            </div>
            <div class="namejob">
              <div class="name">山田紗愛</div>
            </div>
            <div class="namejob">
              <div class="name">林芳平</div>
              <span class="is-size-7">（五十音順、計16名）</span>
            </div>

            <h3 class="h3__margin">協力</h3>
            <div class="namejob">
              <div class="name">松本タイポグラフィ研究会</div>
            </div>
            <!-- <div class="text is-size-8">
              稲岡莉々・落合あや子・佐藤美羽・篠鉄平・朱心茹・榛葉眞利子・鈴木彩恵実・曾國榕・高橋さくら・田中千尋・都筑尭志・舟山貴士・前田凜・松本向日葵・山田紗愛・林芳平
              <span class="is-size-7">（五十音順、計16名）</span> -->

              <!-- <div class="namejob">
                <div class="name">本間由夏</div>
                <div class="centerLine"><hr></div>
                <div class="job">〇〇〇〇〇〇〇〇〇〇</div>
                <p class="is-size-7">※五十音順、計16名、2023年6月現在</p>
              </div> -->

            <!-- </div> -->
          </div>
        </div>
      </section>

      <!-- <section class="works">
        <h2 class="h1">作品展示<a id="works" class="hash_anchor"></a></h2>
        <p class="date" v-if="sessionalStatus === 'pre'" v-html="startDateCountDownStr"></p>
        <p class="caption is-serif has-text-centered" v-if="sessionalStatus === 'pre'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。<br>展示公開日までお待ちください。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'post'">作品の展示は<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>をもちまして終了いたしました。たくさんのご来場・視聴をいただきましてありがとうございました。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'mid'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。作品は作品閲覧からご覧ください。作品の解説は動画解説をご覧ください。</p> -->
        <!-- <img src="../assets/img/2020-05-06_23h06_38.png" alt="" class="works__thumbnail"> -->
        <!-- <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <button class="button" @click="showWorksModal">作品閲覧</button>
          <a href="https://youtu.be/kbLzqaElnnU" target="_blank" class="button">動画解説</a>
        </div> -->
      <!-- </section> -->

      <section class="eyecatch">
        <div class="slideshow"></div>
        <div class="slideshow slideshow2"></div>
        <!-- <img src="../assets/img/eyecatch.jpg" class="scene"> -->
      </section>

      <section class="pamphlet">
        <h2 class="h2">冊子<a id="pamphlet" class="hash_anchor"></a></h2>
        <div class="pamphlet__thumbnail__wrap">
          <img src="../assets/img/pamphlet/pamphlet--01.png" srcset="../assets/img/pamphlet/pamphlet--01.png 1x, ../assets/img/pamphlet/pamphlet--01@2x.png 2x" alt="">
        </div>
        <p class="caption is-serif">制作書体と組見本を収録した冊子を会場にご用意（A4変型／約80ページ）。制作者による書体紹介、小宮山博史さんによる講評、塾長からのコメント等を掲載しています。ご来場の際、お一人様1冊お持ち帰りいただけます。数に限りがあります。無くなりました場合にはご容赦ください。</p>
        <div class="typeface__commentator">
          <div class="columns is-desktop profile__title">
            <div class="column">
              <div class="columns">
                <div class="column is-one-quarter-desktop is-one-third-tablet is-hidden-mobile">
                  <img src="../assets/img/profile/komiyama.jpg" alt="小宮山博史" class="profile__thumbnail">
                </div>
                <div class="column">
                  <h3 class="h3">小宮山博史<span class="is-small">（こみやまひろし）</span></h3>
                  <p class="is-serif calt komiyama__profile">1943年新宿早稲田生まれ。佐藤敬之輔に師事し書体史と書体設計の基礎を学ぶ。元佐藤タイポグラフィ研究所代表。調査・研究と称してしばしば上海に遊び、美華書館の足跡を探す。著書に『<a href="https://ndlsearch.ndl.go.jp/books/R100000002-I000002823739" target="_blank">明朝体活字字形一覧</a>』、『<a href="https://ndlsearch.ndl.go.jp/books/R100000002-I000009993594" target="_blank">日本語活字ものがたり</a>』、『<a href="http://www.graphicsha.co.jp/detail.html?p=42704" target="_blank">明朝体活字</a>』などがある。横浜市在住。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3 class="h3">冊子申込受付期間（第二期受付）</h3>
        <p class="date date--small"><span v-text="$store.getters['getPamphletOrderStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getPamphletOrderStartDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderStartDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderStartDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderStartDate'].format('HH:mm')"></span><span> – </span><br class="is-hidden-tablet"><span v-text="$store.getters['getPamphletOrderEndDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderEndDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderEndDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderEndDate'].format('HH:mm')"></span></p> -->
        <!-- <p class="note">先着200名、1名1冊まで・フォーム送信後に送料として300円を指定口座までお振込いただきます。<br>期日前でも申込数が在庫に達し次第申込フォームの受付を終了します。</p> -->
        <!-- <div class="button__wrapper" v-if="pamphletOrderlStatus === 'mid'">
          <a class="button button--narrowpadding" href="https://docs.google.com/forms/d/e/1FAIpQLSdj7FkRRdB1O0EfaaYdjuM1ZxOn8mn2jNO64mxqZoOJtN4oSQ/viewform" target="_blank">冊子申込フォーム</a>
        </div> -->
      </section>

      <section class="talkevent">
        <h2 class="title h2">トークイベント<a id="talkevent" class="hash_anchor"></a></h2>
        <h3 class="h1">田中義久・鳥海修と見る<span class="is-hidden-desktop"><br></span>文字塾作品</h3>
        <!-- <h3 class="h1" v-if="sessionalStatus === 'mid'"><a href="https://youtu.be/4XufyzoFEc8" target="_blank"><span class="is-hidden-mobile">『</span>今田欣一<br class="is-hidden-tablet">×<br class="is-hidden-tablet">文字塾<span class="is-hidden-mobile">』</span></a></h3> -->

        <div class="caption is-serif mt-7"><p>田中義久さんをゲストにお迎えし、トークイベントを開催いたします。</p><p>塾生が自身の制作書体を紹介、田中さんから感想や質問を投げかけていただき、塾長を交えつつ塾生とディスカッションを行うことで、展示とはまた違う角度から作品を掘り下げていきます。参加者からの質疑応答も予定しております。当日はご参加をお待ちしております。</p>
        <!-- <p>また、トークイベント終了後、参加者の皆さまと文字塾生の交流の場として懇親会を開催いたしますので、ぜひご参加ください。懇親会はどなたでもご参加いただけますが、お申し込みが必要です。トークイベントの参加お申し込み時に開催情報をご確認の上お申し込みください。</p> -->
        </div>

        <h3 class="h3">日時</h3>
        <p class="date"><span v-text="$store.getters['getTalkEventStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getTalkEventStartDate'].format('M')"></span>月<span v-text="$store.getters['getTalkEventStartDate'].format('D')"></span>日（{{$store.getters['getTalkEventStartDate'].format('ddd')}}）<br class="is-hidden-tablet"><span v-text="$store.getters['getTalkEventStartDate'].format('HH:mm')"></span><span> – </span><span v-text="$store.getters['getTalkEventEndDate'].format('HH:mm')"></span><span class="is-size-4 is-size-5-mobile is-size-5-tablet">（開場13:30）</span></p>

        <p class="caption">事前予約制／先着40名様<br>参加費：一般 2,500円／学生 2,000円<br>（現金のみ／当日会場受付にてお支払いください）<br>お申し込み受付は5月3日（金）から開始<span class="is-hidden-desktop"><br></span>（定員に達し次第締切）</p>
        <p class="mt-4 caption notes">＊トークイベント終了後、参加者の皆さまと文字塾生の交流の場として懇親会を開催します。<br/>トークイベントお申し込み時に開催情報をご確認の上、ぜひお申し込みください。</p>
        <div class="button__wrapper" v-if="sessionalStatus === 'pre'">
          <b-field><b-tag type="is-warning"><span>お申し込み受付開始まで今しばらくお待ち下さい</span></b-tag></b-field>
        </div>
        <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <a class="button is-link" href="https://forms.gle/oACqgrtdUvMNxggQ8" target="_blank">トークイベントを予約する</a>
        </div>
        <div class="button__wrapper" v-if="sessionalStatus === 'post'">
          <b-field><b-tag type="is-warning"><span class="is-size-7-mobile">受付を締め切りました。お申し込みありがとうございました。</span></b-tag></b-field>
          <!-- <p class="caption"><a href="#talkevent2">トークイベントその2「書体の背景」</a>は引き続きお申し込み受付中です。<span class="is-hidden-mobile"><br></span>詳細をご確認の上、ぜひお申し込みください。</p> -->
        </div>

        <!-- <div class="columns timetable">
          <div class="column student">
            <h3 class="h3 mt-7">タイムテーブル</h3>
            <div class="text mt-5">
              <div class="namejob">
                <div class="name">開場</div>
                <div class="centerLine"><hr></div>
                <div class="job">13:30</div>
              </div>

              <div class="namejob">
                <div class="name">塾⻑よりご挨拶・ゲストご紹介</div>
                <div class="centerLine"><hr></div>
                <div class="job">14:00</div>
              </div>

              <div class="namejob with--description">
                <div class="name">第1部</div>
                <div class="centerLine"><hr></div>
                <div class="job">14:05</div>
              </div>
              <div class="description">作品毎にディスカッション（6名）</div>

              <div class="namejob">
                <div class="name">休憩</div>
                <div class="centerLine"><hr></div>
                <div class="job">15:00</div>
              </div>

              <div class="namejob with--description">
                <div class="name">第2部</div>
                <div class="centerLine"><hr></div>
                <div class="job">15:10</div>
              </div>
              <div class="description">作品毎にディスカッション（6名）</div>

              <div class="namejob">
                <div class="name">質疑応答</div>
                <div class="centerLine"><hr></div>
                <div class="job">16:30</div>
              </div>

              <div class="namejob">
                <div class="name">塾長よりご挨拶</div>
                <div class="centerLine"><hr></div>
                <div class="job">16:50</div>
                <p class="is-size-7 mt-5">（<span class="is-hidden-mobile">イベントの</span>内容は予告なく変更になる場合がございます）</p>
              </div>

            </div>
          </div>
        </div> -->

        <div class="talk__guest">
          <div class="columns is-desktop profile__title">
            <div class="column">
              <div class="profile__thumbnail__wrap is-hidden-mobile">
                <img src="../assets/img/profile/torinoumi.jpg" alt="鳥海修" class="profile__thumbnail">
              </div>
              <h3 class="h3">鳥海修<span class="is-small">（とりのうみおさむ）</span></h3>
              <p class="is-serif calt">1955年山形県生まれ。<a href="http://www.jiyu-kobo.co.jp/" target="_blank">（有）字游工房</a>の書体設計士。同社の游明朝体、游ゴシック体、（株）SCREENホールディングスのヒラギノシリーズ、こぶりなゴシックなど100書体以上の開発に携わる。字游工房として2002年に第1回佐藤敬之輔賞、ヒラギノシリーズで2005年グッドデザイン賞、2008東京TDC タイプデザイン賞を受賞。2024年、日本文化の向上につくしたとして第58回吉川英治文化賞を受賞。2022年dddギャラリーで個展「もじのうみ」を開催。著書に『<a href="https://www.shobunsha.co.jp/?p=4004" target="_blank">文字を作る仕事</a>』（日本エッセイスト・クラブ賞受賞）、『<a href="http://www.kawade.co.jp/np/isbn/9784309256276/" target="_blank">本をつくる</a>』（共著）、『<a href="https://book-design.jp/works/602/" target="_blank">明朝体の教室</a>』がある。2021年に長野県安曇野市に移住。私塾「<a href="https://www.mojijuku.jp/">松本文字塾</a>」塾長。</p>
            </div>
            <div class="column">
              <div class="profile__thumbnail__wrap is-hidden-mobile">
                <img src="../assets/img/profile/tanaka.jpg" alt="田中義久" class="profile__thumbnail">
              </div>
              <h3 class="h3">田中義久<span class="is-small">（たなかよしひさ）</span></h3>
              <p class="is-serif calt">1980年静岡県生まれ。武蔵野美術大学空間演出デザイン学科卒業、慶應義塾大学政策・メディア研究科修士課程在学中。主な仕事に「東京都写真美術館」のVI計画や、「第58回ヴェネチア・ビエンナーレ国際美術展」、「国際芸術祭あいち2022」、「POST」、「Tokyo Art Book Fair」、「Takeo Paper Show」、「ISSEY MIYAKE」のアートディレクションなどがある。またアーティストデュオ「<a href="http://www.nerhol.com" target="_blank">Nerhol</a>」としても活動し、主な個展に「Beyond the Way」レオノーラ・キャリントン美術館（メキシコ）、「Index」Foam Photography Museum（オランダ）、「Promenade」金沢21世紀美術館などがある。</p>
            </div>
          </div>
        </div>

        <hr>
        <div class="additional__event">
          <div class="is-desktop event__title">
            <h3 class="h3 calt">急遽開催決定！<a id="talkevent2" class="hash_anchor"></a><span class="is-hidden-desktop"><br></span>6月9日（日）文字塾展連動企画<br>トークイベントその2 「書体の背景」</h3>
            <p class="caption mt-5">6月8日（土）のトークイベントで語りつくせなかった（？）文字や活字の話など、<span class="is-hidden-mobile"><br></span>アフタートークを兼ねて二日連続で鳥海塾長に登壇していただきます。
            <!-- <span class="is-hidden-mobile"><br></span><a href="https://forms.gle/Wit97mkBgtXjsU8Y8" target="_blank">こちら</a>から詳細をご確認の上、お申し込みください。 -->
            </p>
            <div class="button__wrapper" v-if="sessionalStatus === 'post'">
              <b-field><b-tag type="is-warning"><span class="is-size-7-mobile">受付を締め切りました。お申し込みありがとうございました。</span></b-tag></b-field>
            </div>
          </div>
        </div>

      </section>

      <div class="fullwidth--wrap bgc">
        <section class="access">
          <h2 class="h2">アクセス<a id="access" class="hash_anchor"></a></h2>
          <div class="columns is-desktop">
            <div class="column">
              <div class="upper__wrap">
                <h3 class="h3 is-size-4">展示会場</h3>
                <div class="map__wrap">
                  <img src="../assets/img/access.png" srcset="../assets/img/access.png 1x, ../assets/img/access@2x.png 2x" alt="" class="full-width">
                </div>
              </div>
              <div class="text__wrap">
                <p class="is-size-5-mobile is-size-4"><a target="_blank" href="https://matsumoto-artcenter.com/">マツモトアートセンター</a></p>
                <p class="mt-5">〒390-0874 <span class="is-hidden-tablet"><br></span>長野県松本市大手1-3-32笠原ビル</p>
                <p><a href="https://www.google.com/maps?ll=36.235244,137.964702&z=14&t=m&hl=ja&gl=US&mapclient=embed&cid=15830418473104481311" target="_blank">Googleマップ</a></p>
                <p>JR松本駅から徒歩約7分<span class="is-hidden-mobile">／</span><span class="is-hidden-desktop"><br></span>JR北松本駅から徒歩約7分</p>
                <p>松本インターから車で約15分</p>
                <p class="is-size-6 mt-2">＊お車でお越しの場合は近隣のコインパーキングをご利用ください。</p>
              </div>
          </div>
          <div class="column">
            <div class="upper__wrap">
              <h3 class="h3 is-size-4">トークイベント会場</h3>
              <div class="map__wrap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3218.1572173300524!2d137.96693281203272!3d36.2356746722984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601d0e8fb27cb4f5%3A0x930370da2a2281e!2z44Ku44Oj44Op44Oq44O844OO44Kk44Ko!5e0!3m2!1sja!2sjp!4v1713617480523!5m2!1sja!2sjp" width="753" height="402" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
            <div class="text__wrap">
              <p class="is-size-5-mobile is-size-4"><a target="_blank" href="https://noyie.jp/">ギャラリーノイエ</a></p>
              <p class="mt-5">〒390-0874　<span class="is-hidden-tablet"><br></span>長野県松本市大手3丁目2-17</p>
              <p><a href="https://maps.app.goo.gl/VWHY8RDR1ddmBTjy7" target="_blank">Googleマップ</a></p>
              <p>JR松本駅から徒歩約9分<br>展示会場から徒歩約7分</p>
              <p class="is-size-6 mt-2">＊お車でお越しの場合は近隣のコインパーキングをご利用ください。</p>
            </div>
            </div>
          </div>
        </section>
      </div>

      <section class="qanda">
        <h2 class="h2">Q&amp;A<a id="qanda" class="hash_anchor"></a></h2>
        <!-- <div class="qawrap">
          <h3 class="h3">松本文字塾 文字塾展（2023年6月開催）と内容は異なりますか？</h3>
          <p class="caption is-serif">各作品の展示はB3サイズの組見本パネルのみとなり、字形一覧のパネルはございません。松本での展示同様に制作ファイルの設置がございます。本展示では、塾生の作品ごとに、松本文字塾第一期に通った感想が掲示されます。</p>
        </div> -->
        <div class="qawrap">
          <h3 class="h3">オンラインでの作品展示やトークイベントの配信はありますか？</h3>
          <p class="caption is-serif">会期中のオンラインでの作品掲示やトークイベントの配信は予定されておりません。ぜひ会期中に会場へお越しください。</p>
        </div>
        <div class="qawrap">
          <h3 class="h3">冊子はどこで入手できますか？</h3>
          <p class="caption is-serif">会期中に展示会場でご入手いただけます。その他での頒布は現在予定しておりません。また数に限りがあるためお一人様1冊とさせていただきます。予めご了承ください。</p>
        </div>
        <div class="qawrap">
          <h3 class="h3">会場内の撮影は可能ですか？</h3>
          <p class="caption is-serif">パネルを含む会場内の撮影は原則自由となります。作品ファイルの撮影は不可です。展示スタッフから指示がある場合は指示に従ってください。トークイベントでの撮影については当日のアナウンスに従ってください。</p>
        </div>
        <!-- <div class="button__wrapper"><a href="https://forms.gle/VG4eidgUN6obfxbZ6" target="_blank" class="button is-link">松本文字塾第二期文字塾展について問い合わせる</a></div> -->
      </section>

      <footer>Copyright © Mojijuku All rights reserved.<br>当サイトに掲載されている文章及び画像の無断利用を禁じます。</footer>
    </div>
    <!-- <b-modal :active.sync="isWorksModalActive" :width="683" scroll="keep" class="works__modal">
      <div class="works__thumb__header">閲覧する作品を選択してください</div>
      <div class="works__thumb__wrap">
        <div class="works__thumb__item">
          <router-link to="/imaichitatsuya"><img src="../assets/img/works/imaichitatsuya@2x.png" srcset="../assets/img/works/imaichitatsuya@2x.png 1x, ../assets/img/works/imaichitatsuya@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kuroiwamio"><img src="../assets/img/works/kuroiwamio@2x.png" srcset="../assets/img/works/kuroiwamio@2x.png 1x, ../assets/img/works/kuroiwamio@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/dohiyurika"><img src="../assets/img/works/dohiyurika@2x.png" srcset="../assets/img/works/dohiyurika@2x.png 1x, ../assets/img/works/dohiyurika@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/iwasakinanami"><img src="../assets/img/works/iwasakinanami@2x.png" srcset="../assets/img/works/iwasakinanami@2x.png 1x, ../assets/img/works/iwasakinanami@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/shimizuyuto"><img src="../assets/img/works/shimizuyuto@2x.png" srcset="../assets/img/works/shimizuyuto@2x.png 1x, ../assets/img/works/shimizuyuto@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/abehirosuke"><img src="../assets/img/works/abehirosuke@2x.png" srcset="../assets/img/works/abehirosuke@2x.png 1x, ../assets/img/works/abehirosuke@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kiibunpei"><img src="../assets/img/works/kiibunpei@2x.png" srcset="../assets/img/works/kiibunpei@2x.png 1x, ../assets/img/works/kiibunpei@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kudoukazuhiko"><img src="../assets/img/works/kudoukazuhiko@2x.png" srcset="../assets/img/works/kudoukazuhiko@2x.png 1x, ../assets/img/works/kudoukazuhiko@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kliopeng"><img src="../assets/img/works/kliopeng@2x.png" srcset="../assets/img/works/kliopeng@2x.png 1x, ../assets/img/works/kliopeng@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/joechang"><img src="../assets/img/works/joechang@2x.png" srcset="../assets/img/works/joechang@2x.png 1x, ../assets/img/works/joechang@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/hibinojunko"><img src="../assets/img/works/hibinojunko@2x.png" srcset="../assets/img/works/hibinojunko@2x.png 1x, ../assets/img/works/hibinojunko@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/tsunodaakitoshi"><img src="../assets/img/works/tsunodaakitoshi@2x.png" srcset="../assets/img/works/tsunodaakitoshi@2x.png 1x, ../assets/img/works/tsunodaakitoshi@3x.png 3x" alt=""></router-link>
        </div>
      </div>
      <button class="modal-close is-large" @click="hideWorksModal"></button>
    </b-modal> -->
  </div>
</template>

<script>

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

setInterval(function () {//一秒間に一回再取得

}, 1000);

// For scroll animation

// constant elements: your main scrolling element; html element
const scrollEl = document.documentElement;
const root = document.documentElement;

let scrollPos;

// update css property on scroll
function animation() {
  // check the scroll position has changed
  if (scrollPos !== scrollEl.scrollTop) {
    // reset the seen scroll position
    scrollPos = scrollEl.scrollTop;
    // update css property --scrollPos with scroll position in pixels
    root.style.setProperty('--scrollPos', scrollPos + 'px');
  }

  // call animation again on next animation frame
  window.requestAnimationFrame(animation);
}

// start animation on next animation frame
window.requestAnimationFrame(animation);


export default {
  name: 'Home',
  components: {
  },
  computed: {
    startCountDownChanges: {
      get : function(){
        return this.startDateCountDownStr;
      },
      set : function(v){
        this.startDateCountDownStr =  v;
      }
    },
    sessionalStatus() {
      const nowDate = dayjs()
      let   thisSessionalStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getTalkEventBookStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getTalkEventBookEndDate'])) {
          // 終了日以前
          thisSessionalStatus = 'mid';
        } else {
          // 終了日以降
          thisSessionalStatus = 'post';
        }
      } else {
        // 開始日以前
        thisSessionalStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisSessionalStatus = 'mid';
        console.log('mid')
      } else if(this.$route.name === 'Home-post') {
        thisSessionalStatus = 'post';
        console.log('post')
      }
      this.$store.dispatch('updateSessionalStatus', thisSessionalStatus)
      return this.$store.getters['getSessionalStatus']
    },
    time() {
      return this.$store.state.eventStartDate.format('HH:mm:ss')
    },
    pamphletOrderlStatus() {
      const nowDate = dayjs()
      let   thisPamphletOrderStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getPamphletOrderStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getPamphletOrderEndDate'])) {
          // 終了日以前
          thisPamphletOrderStatus = 'mid';
        } else {
          // 終了日以降
          thisPamphletOrderStatus = 'post';
        }
      } else {
        // 開始日以前
        thisPamphletOrderStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisPamphletOrderStatus = 'mid';
      } else if(this.$route.name === 'Home-post') {
        thisPamphletOrderStatus = 'post';
      }
      this.$store.dispatch('updatePamphletOrderStatus', thisPamphletOrderStatus)
      return this.$store.getters['getPamphletOrderStatus']
    },
  },
  mounted: function(){
    this.updateStartCountDownChanges();
  },
  beforeDestroy () {
    clearInterval(this.startDateCountDownInterval)
  },
  methods: {
    // 作品閲覧クリック用method
    showWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', true)
      this.isWorksModalActive = true
      this.$gtag.event('modal', { method: 'showWorksList' })
    },
    hideWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', false)
      this.isWorksModalActive = false
    },
    afterEnter () {
      this.isWorksModalActive = this.$store.getters['getIsWorksModalActive']
    },
    afterLeave () {
      // this.$root.$emit('triggerScroll')
    },
    updateStartCountDownChanges (){
      this.startDateCountDownInterval = setInterval(function(){
        // diffメソッドを使って、日時の差を、ミリ秒で取得
        const diff = this.$store.getters['getStartDate'].diff( dayjs() );

        // ミリ秒からdurationオブジェクトを生成
        const duration = dayjs.duration( diff );

        // 日・時・分・秒を取得
        const days = Math.floor( duration.asDays());
        const hours   = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        const nowDate = dayjs()
        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
          if (nowDate.isAfter(this.$store.getters['getStartDate'])) {
            if (nowDate.isBefore(this.$store.getters['getEndDate'])) {
              this.$store.dispatch('updateSessionalStatus', 'mid')
            } else {
              this.$store.dispatch('updateSessionalStatus', 'post')
            }
          }
        }

        //カウントダウンの結果を変数に代入
        this.startCountDownChanges = '開催まであと<br><span>' + days + '</span>日<span>' +  hours + '</span>時間<span>' + minutes + '</span>分<span>' + seconds + '</span>秒';
      }.bind(this), 1000);
    }
  },
  data() {
    return {
      isWorksModalActive: this.$store.getters['getIsWorksModalActive'],
      startDateCountDownStr: '',
      startDateCountDownInterval: undefined,
    }
  }
}
</script>
